module.exports = __webpack_public_path__ + "static/img/14.423d7cb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/1/sp/14.png
// module id = r8b9
// module chunks = 0